import { useState, useEffect, useContext } from 'react';
import { CsrfContext } from '../contexts/CsrfSyncContext';
import API from '../api/axiosConfig';

const useAuth = () => {
  const { csrfToken, isLoading: csrfLoading } = useContext(CsrfContext);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Only check auth status when CSRF token is ready
    if (!csrfLoading && csrfToken) {
      checkAuthStatus();
    } else if (!csrfLoading && !csrfToken) {
      // If CSRF token failed to load, mark as not loading
      setIsLoading(false);
      setIsAuthenticated(false);
    }
  }, [csrfToken, csrfLoading]);

  const checkAuthStatus = async () => {
    try {
      setIsLoading(true);
      const response = await API.get('/web/auth/status');
      setIsAuthenticated(response.data.authenticated);
    } catch (err) {
      console.error('Auth status check failed:', err);
      setIsAuthenticated(false);
    } finally {
      setIsLoading(false);
    }
  };

  return { isAuthenticated, isLoading: isLoading || csrfLoading };
};

export default useAuth;